import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=c30843d4&scoped=true&"
import script from "./SearchResults.vue?vue&type=script&lang=ts&"
export * from "./SearchResults.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=c30843d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30843d4",
  null
  
)

export default component.exports